module.exports = __webpack_public_path__ + "static/media/ico_message.421ba3b7.svg";